import { render, staticRenderFns } from "./MesasCuentas.vue?vue&type=template&id=a67d8764"
import script from "./MesasCuentas.vue?vue&type=script&lang=js"
export * from "./MesasCuentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports